import { connect } from "redux-vue";
import {deviceSupport} from "../helpers/tools";
import * as moduleActions from "../actions/module";
import LoadingIndicator from "../components/LoadingIndicator";
import ModalTemplate, {modalPageDecorator} from "./ModalTemplate";
import classNames from "classnames";

const CourseDetailModal = modalPageDecorator({
  /**
   *
   */
  props: ['user', 'module', 'fetchModule', 'enrollModule'],

  /**
   *
   */
  mounted() {
    if (!this.module.model) {
      // this.fetchModule(this.$route.params.id);
      this.$router.go(-1);
    }
  },

  /**
   *
   */
  methods: {
    async handleEnroll () {
      const isAuthorized = !!(this.user.token && this.user.model);
      if (!isAuthorized) {
        this.$router.push({name: 'RegisterModal'});
      } else {
        const hasActivity = (this.module.model.lessons || []).some(lesson => !!lesson.activities.length);
        if (hasActivity) {
          await this.enrollModule(this.module.model);
          if (this.module.enrollSuccess) {
            this.$router.replace({name: 'CoursesPage'});
          }
        } else {
          Snackbar.show({
            text: 'This module will be available soon',
            actionText: 'Dismiss',
          });
        }
      }
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const mobileClass = classNames(
      "mdi text-teal-800 text-sm lg:text-base",
      this.module.model && this.module.model.mobile ? 'mdi-cellphone' : 'mdi-cellphone-off opacity-25'
    );

    const desktopClass = classNames(
      "mdi text-teal-800 text-sm lg:text-base",
      this.module.model && this.module.model.desktop ? 'mdi-laptop' : 'mdi-laptop-off opacity-25'
    );
    
    const lessonDetailSource = this.module.model && 
    (this.module.model.metadata.detail_lessons) ? this.module.model.metadata.detail_lessons : this.module.model.lessons;

    return (
      <ModalTemplate>
        {this.module.model && (
          <div class="m-2 lg:my-12">
            <div class="bg-white container p-8 pt-12 lg:p-12 md:max-w-6xl mx-auto rounded shadow-lg relative z-50">

              <div onClick={this.dismiss} class="cursor-pointer z-50 absolute top-0 right-0 m-5">
                <i class="mdi mdi-close text-3xl lg:text-4xl leading-none"></i>
              </div>

              <h2 class="text-2xl lg:text-3xl font-bold my-2">
                {this.module.model.name}
              </h2>

              <div class="flex flex-wrap mb-5 lg:mb-0">
                <div class="w-full lg:w-6/12">
                  <p class="py-3 font-bold text-sm">
                    Course Summary
                  </p>
                  <p class="text-sm text-gray-600 mb-5 lg:mb-10" domPropsInnerHTML={this.module.model.summary}>
                  </p>
                  <div class="flex items-center mb-5 lg:mb-0">
                    <div class="bg-teal-100 rounded-full h-8 w-8 mr-1">
                      <div class="w-full h-full flex items-center justify-center">
                        <i class={mobileClass}></i>
                      </div>
                    </div>
                    <div class="bg-teal-100 rounded-full h-8 w-8 mr-2">
                      <div class="w-full h-full flex items-center justify-center">
                        <i class={desktopClass}></i>
                      </div>
                    </div>
                    <small>
                      {deviceSupport(this.module.model)}
                    </small>
                  </div>
                  <p class="py-3 font-bold text-sm">
                    Estimated Time
                  </p>
                  <p class="text-sm text-gray-700 mb-5 lg:mb-10">
                    {this.module.model.estimated_time}
                  </p>
                </div>
                <div class="w-full lg:w-5/12 lg:ml-auto">
                  <p class="py-3 font-bold text-sm">
                    Lessons
                  </p>
                  <div class="bg-teal-100 overflow-y-auto flex-1 max-h-350px p-4 text-sm">
                    
                    {lessonDetailSource.map(x => (
                      <fragment>
                        <p class="font-bold mb-2 text-gray-900">
                          {x.name}
                        </p>
                        {x.activities && (
                        <ul class="text-gray-900 list-disc pl-10 mb-3">
                          {x.activities.map(y => (
                            <li key={y.id}>
                              {y.name}
                            </li>
                          ))}
                        </ul>)}
                      </fragment>
                    ))}
                  </div>
                </div>
              </div>

              <button disabled={this.module.enroll} onClick={this.handleEnroll}
                class="flex-shrink-0 lg:mr-8 my-3 lg:my-0 px-3 p-2 lg:p-3 rounded-full font-serif bg-yellow-500 focus:outline-none italic"
                type="button">
                {this.module.enroll
                  ? <LoadingIndicator/>
                  : <fragment>Enroll <i class="mdi mdi-arrow-right ml-2"></i></fragment>
                }
              </button>
            </div>
          </div>
        )}
      </ModalTemplate>
    )
  }
});

function mapStateToProps(state) {
  return {
    user: state.user,
    module: state.module
  };
}

function mapActionToProps(dispatch) {
  return {
    fetchModule: id => dispatch(moduleActions.fetchModule(id)),
    enrollModule: async module => await dispatch(moduleActions.enrollModule(module))
  }
}

export default connect(mapStateToProps, mapActionToProps)(CourseDetailModal);
